import { CustomCellEditorProps } from "ag-grid-react";
import { Input } from "antd";
import { useState, useRef, useEffect } from "react";

type Props = CustomCellEditorProps & {};
function UserNameCellEditor(props: Props) {
  const { data, stopEditing, onValueChange } = props;

  const firstNameInputRef: any = useRef();

  const [firstNameValue, setFirstNameValue] = useState(
    data.user.first_name || ""
  );
  const [lastNameValue, setLastNameValue] = useState(data.user.last_name || "");

  useEffect(() => {
    firstNameInputRef.current?.focus();
  }, [data]);

  useEffect(() => {
    return () => {
      onValueChange({ firstNameValue, lastNameValue });
    };
  }, [firstNameValue, lastNameValue, onValueChange]);

  return (
    <div className="flex w-full h-full items-center">
      <div className="flex w-full">
        <Input
          placeholder="*First Name"
          className="w-2/5"
          tabIndex={0}
          type="text"
          ref={firstNameInputRef}
          value={firstNameValue}
          onChange={(event: any) => {
            setFirstNameValue(event.target.value);
          }}
          onPressEnter={(event: any) => {
            setFirstNameValue(event.target.value);
            stopEditing();
          }}
          data-testid="usernamecelleditor-input-fname"
        />
        <Input
          placeholder="Last Name"
          className="w-3/5"
          tabIndex={0}
          value={lastNameValue}
          onChange={(event: any) => {
            setLastNameValue(event.target.value);
          }}
          onPressEnter={(event: any) => {
            setLastNameValue(event.target.value);
            stopEditing();
          }}
          data-testid="usernamecelleditor-input-lname"
        />
      </div>
    </div>
  );
}

export default UserNameCellEditor;
